import React from 'react';
import { Link } from 'react-router-dom';
import './BlogTags.css';

/** Tag value to exclude from display (e.g. placeholder entries) */
export const BLOG_PLACEHOLDER_TAG = 'placeholder';

export function getDisplayTags(tags: string[]): string[] {
  return tags.filter((t) => t !== BLOG_PLACEHOLDER_TAG);
}

interface BlogTagsProps {
  tags: string[];
  className?: string;
  /** When true, each tag links to /blog?tag=... for filtering on the list page */
  linkToBlogList?: boolean;
  /** Locale for blog list URL when linkToBlogList is true (e.g. "en" or "da") */
  locale?: string;
}

const BlogTags: React.FC<BlogTagsProps> = ({ tags, className = '', linkToBlogList = false, locale = 'en' }) => {
  const displayTags = getDisplayTags(tags);
  if (displayTags.length === 0) return null;

  return (
    <div className={`blog-tags ${className}`.trim()} role="list">
      {displayTags.map((tag) =>
        linkToBlogList ? (
          <Link
            key={tag}
            to={`${locale === 'da' ? '/da/blog' : '/blog'}?tag=${encodeURIComponent(tag)}`}
            className="blog-tag blog-tag-link"
            role="listitem"
          >
            {tag}
          </Link>
        ) : (
          <span key={tag} className="blog-tag" role="listitem">
            {tag}
          </span>
        )
      )}
    </div>
  );
};

export default BlogTags;
